/**
 * Single source of truth for social OAuth client IDs.
 *
 * These were previously duplicated across each app's `constants/extras.ts` and
 * every platform's `linkAccount/.../constants.ts`. That let the TikTok ID drift
 * — center/creator-portal shipped a stale value (7382050765054935041) while the
 * mobile/native flow used the correct one. Import these from here only; never
 * re-declare the literals at a call site.
 */
export const SOCIAL_CLIENT_IDS = {
  tiktok: "7380168638092804112",
  instagram: "1078882880613416",
} as const;

export const TIKTOK_CLIENT_ID = SOCIAL_CLIENT_IDS.tiktok;
export const INSTAGRAM_CLIENT_ID = SOCIAL_CLIENT_IDS.instagram;
